"use client"

import { useEffect, useSyncExternalStore } from "react"
import { useRouter } from "next/navigation"
import { Capacitor } from "@capacitor/core"

// Ser nativo no cambia durante la vida de la página: no hay a qué suscribirse.
const subscribe = () => () => {}
const isNative = () => Capacitor.isNativePlatform()
const notNativeOnServer = () => false

/**
 * La app NATIVA nunca debe quedarse en el portal web: no tiene forma de
 * emparejar dispositivos ni de arrancar como POS/KDS/pantalla. Este es el
 * ESPEJO del guard inverso en app/tablet/page.tsx (no-nativo → /login): si un
 * redirect del servidor (verifyAccess / [slug]/layout / verifyMerchantAccess →
 * redirect('/login')) empuja una tablet al portal cuando se le vence la sesión,
 * la devolvemos a /tablet, donde vive el flujo completo (iniciar sesión +
 * entrar con código + emparejar dispositivo). Sin loop: /tablet solo rebota a
 * /login cuando NO es nativo. isNativePlatform() es síncrono.
 *
 * S5-4: vive aparte para que el resto de /login sea server component. En el
 * servidor vale `false` (el HTML trae el formulario); al hidratar en la app
 * nativa tapa la página con el mismo fondo oscuro mientras redirige.
 */
export function NativeTabletRedirect() {
  const router = useRouter()
  const native = useSyncExternalStore(subscribe, isNative, notNativeOnServer)

  useEffect(() => {
    if (native) router.replace("/tablet")
  }, [native, router])

  if (!native) return null
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center" style={{ background: "var(--redy-charcoal)" }}>
      <div className="w-8 h-8 rounded-full border-2 border-white/20 border-t-white animate-spin" />
    </div>
  )
}
